import {Component, Input} from "@angular/core";

@Component({
    selector: "fui-panels-alert",
    styleUrls: ["./panels-alert.component.scss"],
    templateUrl: "./panels-alert.component.html"
})
export class FUIPanelsAlertComponent {
    @Input() description: string;
    @Input() title: string;
}
